import reducer from './reducer'
import * as types from './types'
import * as actions from './actions'

export { types, actions }
export default reducer
